import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const MoveInDate = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/move-in-date/components/MoveInDateContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default MoveInDate;
